export const donationGridItemFrag = `
    id
    receivedAt
    donorId
    donorName
    isDonation
    donationForm {
        id
        name
    }
    collectionId
    collectionName
    amount
    source
    variableSymbol
    specificSymbol
    comment
    amountWithoutFee
    recurringPayment
    donor {
        emails {
            email
        }
        phones {
            phone
        }
    }
`;



export const donationGridItemDetailFrag = `
    id
    createdAt
    createdBy
    receivedAt
    originalReceivedAt
    donorId
    donorName
    isDonation
    donationForm {
        id
        name
    }
    collectionId
    collectionName
    amount
    originalAmount
    source
    transactionId
    variableSymbol
    constantSymbol
    specificSymbol
    debtorIban
    debtorName
    creditorIban
    projectId
    webGatewayId
    webGatewayIntegrationName
    newsletter
    webpageSource
    organizationName
    sentEmails {
        date
        kind
        path
    }
    recurringPayment
    comment
    reports {
        donorId
        date
        comment
        isDone
    }
    amountWithoutFee
    accountingDate
`
